export default function toggleStopScroll (isStopScroll) {
  const bodyEl = document.querySelector('body')
  const htmlEl = document.querySelector('html')
  if (isStopScroll) {
    bodyEl.classList.add('is-stop-scroll')
    htmlEl.classList.add('is-stop-scroll')
  } else {
    bodyEl.classList.remove('is-stop-scroll')
    htmlEl.classList.remove('is-stop-scroll')
  }
}



// WEBPACK FOOTER //
// ./src/utils/toggleStopScroll.js